import { formClassStaff, SexFlug } from "../../../assets/data/Constants";
import TkDownloadLink from "../../../components/atoms/TkDownloadLink";
import { IAPI_CON003_Response } from "../../../type/apiType";
import { TkGetCode } from "../../../utils/TkGetCode";
import "../_style.scss";

function funBodyList(res: IAPI_CON003_Response) {
  const bodyList = res.staffList?.map((item) => {
    const file = res.formList?.find(
      (formData) =>
        item.staffNo === formData.staffNo &&
        formData.formClass === formClassStaff["雇用契約書の写し"]
    );
    return [
      {
        children: (item.staffNo ?? "") + ":" + (item.staffNameKanji ?? ""),
      },
      {
        children: TkGetCode(SexFlug, item.sex),
        align: "center",
      },
      {
        children: item.birthday,
        align: "center",
      },
      {
        children: item.joinDate,
        align: "center",
      },
      {
        children: (
          <TkDownloadLink
            base64filedata={file?.fileBase64 ?? ""}
            dataname={file?.fileName ?? ""}
            downloadBase64={true}
          />
        ),
      },
    ];
  });

  return bodyList;
}

export { funBodyList };
